import styled from '@emotion/styled';
const Link = styled.a `
  border: none;
  color: ${({ theme }) => theme.colors.interactions.link.default};
  display: inline-block;
  text-decoration: none;
  cursor: pointer;

  &:link,
  &:visited {
    color: ${({ theme }) => theme.colors.interactions.link.default};
  }
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.interactions.link.hover};
  }
  &:active {
    color: ${({ theme }) => theme.colors.interactions.link.active};
  }
`;
export default Link;
